import { useEffect, useMemo } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import classNames from "classnames";
import { useCompanyDateFormat, useCompanyWeekStartsOn } from "../../../utils/hooks/company";
import sq from "date-fns/locale/sq";
import en from "date-fns/locale/en-GB";
import es from "date-fns/locale/es";
import "./style.scss";

function DateInput({
	className,
	calendarClassName,
	hasError,
	value,
	dateFormat,
	...props
}) {
	const companyDateFormat = useCompanyDateFormat();
	const calendarStartDay = useCompanyWeekStartsOn();

	const language = localStorage.getItem("i18nextLng");

	const format = useMemo(() => {
		return companyDateFormat !== null || !dateFormat
			? companyDateFormat?.replace("YYYY", "yyyy")?.replace("DD", "dd")
			: dateFormat;
	}, [companyDateFormat, dateFormat]);

	const lng = useMemo(() => {
		if (language === "sq") {
			return sq;
		} else if (language === "es") {
			return es;
		} else {
			return en
		}
	}, [language])

	useEffect(() => {
		registerLocale(language, lng);
	}, [language, lng])

	return (
		<DatePicker
			dateFormat={format}
			showFourColumnMonthYearPicker
			calendarStartDay={calendarStartDay}
			locale={lng}
			{...props}
			className={classNames(
				className,
				"form-control",
				hasError && "invalid-date-time-input",
			)}
			calendarClassName={classNames(
				calendarClassName,
				"custom-date-picker",
			)}
			selected={value}
			portalId="datepicker-portal"
		/>
	);
}

export default DateInput;
